(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("react"), require("@bingads-webui/state-store"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "react", "@bingads-webui/state-store"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("react"), require("@bingads-webui/state-store")) : factory(root["underscore"], root["react"], root["@bingads-webui/state-store"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__31__, __WEBPACK_EXTERNAL_MODULE__193__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 190);
/******/ })
/************************************************************************/
/******/ ({

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(191);


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withStateStore", {
  enumerable: true,
  get: function get() {
    return _withStateStore.withStateStore;
  }
});

var _withStateStore = __webpack_require__(192);

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStateStore = withStateStore;

var _stateStore = __webpack_require__(193);

var _react = _interopRequireDefault(__webpack_require__(31));

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function withStateStore(ComponentToWrap, storeFactory, selector) {
  if (selector === void 0) {
    selector = 'store';
  }

  if (typeof storeFactory !== 'function') {
    var store_1 = storeFactory;

    storeFactory = function storeFactory() {
      return store_1;
    };
  }

  var select = selector;

  if (typeof selector === 'string') {
    var storeName_1 = selector;

    select = function select(store) {
      var res = {};
      res[storeName_1] = store;
      return res;
    };
  }

  var WrappedComponent =
  /** @class */
  function (_super) {
    __extends(WrappedComponent, _super);

    function WrappedComponent(props) {
      var _this = _super.call(this, props) || this;

      _this.state = {};
      _this.store = _this.createStore();
      return _this;
    }

    WrappedComponent.prototype.createStore = function () {
      if (storeFactory instanceof _stateStore.StateStore) {
        return storeFactory;
      } else {
        return storeFactory();
      }
    };

    WrappedComponent.prototype.componentDidMount = function () {
      this.subscribe();
    };

    WrappedComponent.prototype.componentWillUnmount = function () {
      this.unsubscribe();
    };

    WrappedComponent.prototype.subscribe = function () {
      var _this = this;

      this.subscription = this.store.subscribe(function (state) {
        var _a;

        if (!((_a = _this.subscription) === null || _a === void 0 ? void 0 : _a.closed)) {
          _this.setState(state);
        }
      });
    };

    WrappedComponent.prototype.unsubscribe = function () {
      this.subscription.unsubscribe();
    };

    WrappedComponent.prototype.render = function () {
      var props = _underscore.default.extend({}, this.props, select(this.store));

      return _react.default.createElement(ComponentToWrap, __assign({}, props, {
        ref: this.props.forwardedRef
      }));
    };

    return WrappedComponent;
  }(_react.default.PureComponent);

  return _react.default.forwardRef(function (props, ref) {
    return _react.default.createElement(WrappedComponent, __assign({}, props, {
      forwardedRef: ref
    }));
  });
}

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__193__;

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__31__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ })

/******/ });
});
